export default __webpack_public_path__ + "static/media/Soraski.1ebe366d.svg";